import { render, staticRenderFns } from "./paper-required-fields-update-for-citation-popup.html?vue&type=template&id=9b7b590c&scoped=true&"
import script from "./paper-required-fields-update-for-citation-popup.js?vue&type=script&lang=js&"
export * from "./paper-required-fields-update-for-citation-popup.js?vue&type=script&lang=js&"
import style0 from "./paper-required-fields-update-for-citation-popup.scss?vue&type=style&index=0&id=9b7b590c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b7b590c",
  null
  
)

export default component.exports